export const BASE_URL = "https://medayus.sanvima.net/slimapi/api/v1";
export const ASSET_URL = "https://medayus.sanvima.net";